import { Fancybox } from '@fancyapps/ui'

document.querySelectorAll('.wp-block-gallery').forEach((gallery, galleryIndex) => {
    gallery.querySelectorAll('.wp-block-image picture').forEach((picture) => {
        const img = picture.querySelector('img')

        if (!img) {
            return
        }

        const link = document.createElement('a')

        link.href = img.src
        link.dataset.fancybox = `gallery-${galleryIndex}`

        picture.parentNode.insertBefore(link, picture)
        link.appendChild(picture)
    })
})

Fancybox.bind('[data-fancybox]')